import React from 'react';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import { Navbar, ThemeProvider } from './components/navbar/navbar';
import { AppRoutes } from './routes/app-routes';
import { ToastContainer } from 'react-toastify';

function App() {
    return (
        <BrowserRouter>
              <ThemeProvider>
                <div className="App">
                    <>
                        <ToastContainer />
                        <Navbar />
                        <AppRoutes />
                    </>
                </div>
             </ThemeProvider>
        </BrowserRouter>
    );
}

export default App;
